import { apiPost } from '../client';
import {
  EmptyResponseSchema,
  LoginResponseSchema,
  WhatsAppLoginChallengeSchema,
  WhatsAppLoginPollSchema,
  type LoginResponse,
  type WhatsAppLoginChallenge,
  type WhatsAppLoginPoll,
} from '../schemas';

/** A WhatsApp the person just proved and that no access opens yet: the password login links it. */
export type WhatsAppLink = { challengeId: string; pollToken: string };

export function login(
  identifier: string,
  password: string,
  deviceId?: string,
  whatsappLink?: WhatsAppLink,
): Promise<LoginResponse> {
  return apiPost('/v1/business/auth/login', LoginResponseSchema, {
    identifier,
    password,
    ...(deviceId ? { deviceId } : {}),
    ...(whatsappLink ? { whatsappLink } : {}),
  });
}

/** Asks for a one-time code to send Dale from the person's own WhatsApp. */
export function startWhatsAppLogin(): Promise<WhatsAppLoginChallenge> {
  return apiPost('/v1/business/auth/whatsapp/start', WhatsAppLoginChallengeSchema, {});
}

/**
 * One poll: `{ status: 'pending' }` until Dale has the message, then the same
 * body the password login answers. 409 `whatsapp_not_linked` means the number
 * was proven but no access opens with it yet.
 */
export function completeWhatsAppLogin(input: WhatsAppLink & { deviceId: string }): Promise<WhatsAppLoginPoll> {
  return apiPost('/v1/business/auth/whatsapp/complete', WhatsAppLoginPollSchema, input);
}

export function changePassword(
  currentPassword: string,
  newPassword: string,
  idempotencyKey: string,
): Promise<undefined> {
  return apiPost(
    '/v1/business/auth/password',
    EmptyResponseSchema,
    { currentPassword, newPassword },
    idempotencyKey,
  );
}

export function logout(): Promise<undefined> {
  return apiPost('/v1/business/auth/logout', EmptyResponseSchema);
}
